import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"Campaign Player Details"}
                            endpoint={"campaign-player-currency/read"}
                            relations={["campaign", "player_currency.player", "player_currency.currency"]} />
}

export default GameSessionDetailsPage;